module.exports = __webpack_public_path__ + "0fe9575c22e93269439c1b67abd38ddb.jpg";